document.addEventListener("DOMContentLoaded", (event) => {

    const button = document.getElementById('load-mit');

    if(button){
        let maxInnungen = button.dataset.max;
        const InnungenExcept = button.dataset.except;
        const parent = button.parentElement;

        if(InnungenExcept){
            maxInnungen = parseInt(maxInnungen, 10) -1;
        }else{
            let InnungenExcept = "";
        }

        var $ = require('jquery');

        button.addEventListener('click', ()=>{
            
            if( maxInnungen > button.dataset.mitint){
                button.dataset.mitint = parseInt(button.dataset.mitint, 10) + 3;
                let num = button.dataset.mitint;
                
                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'html',
                    data: {
                        num: num,
                        except: InnungenExcept,
                        action: 'load_innungen',
                    },
                    success: function (res) {
                        $('#innungen').html(res);
                    }
                }) 

                if(maxInnungen < parseInt(button.dataset.mitint, 10)){
                    parent.removeChild(button);
                }
                
            }
            
        });
    }
    
});